import objectDifference from './objectDifference';

/**
 * Only sane for same-ordered objects i.e. ones passed in via props
 * @param {T} obj1
 * @param {T} obj2
 * @returns {boolean}
 */
export default function isObjectEqual<T extends object>(obj1: T, obj2: T) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}